import MultiStepsForm from "./form-steps";
export default MultiStepsForm;
